<!--
 * @Description: 流出批次详情
 * @Author: WuPuyi
 * @LastEditors: WuPuyi
 * @Date: 2020-12-02 09:49:47
 * @LastEditTime: 2020-12-30 15:43:38
-->
<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        流出批次信息
        <span class="batch-abstract">
          <span class="batch-abstract-item">
            园区服务企业数量：{{ batchAbstract.serviceCorp }}
          </span>
          <span class="batch-abstract-item">
            食品经营企业数量：{{ batchAbstract.foodBusinessCorp }}
          </span>
          <span class="batch-abstract-item">
            商品类型数：{{ batchAbstract.goodsType }}
          </span>
        </span>
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            icon="e6-icon-field_line"
            title="表格列设置"
            @click="columSetVisible = true"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            v-if="operationSuper.导出"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.timeRange">
            <el-date-picker
              v-model="slotForms.forms.timeRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="datePickerOptions"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="forms.outStorageCode" class="form-item_2">
            <el-input
              v-model="slotForms.forms.outStorageCode"
              placeholder="出库编号"
            ></el-input>
          </el-form-item>
          <el-form-item prop="forms.storageCompanyId" class="form-item_2">
            <el-select
              v-model="slotForms.forms.storageCompanyId"
              clearable
              filterable
              placeholder="园区服务企业名称"
              :loading="parkServiceCorpLoading"
            >
              <el-option
                v-for="item in parkServiceCorpList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="forms.foodCompanyId" class="form-item_2">
            <el-select
              v-model="slotForms.forms.foodCompanyId"
              clearable
              filterable
              placeholder="食品经营企业名称"
              :loading="foodBusinessCorpLoading"
            >
              <el-option
                v-for="item in foodBusinessCorpList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="forms.goodsName" class="form-item_2">
            <el-input
              v-model="slotForms.forms.goodsName"
              placeholder="商品名称/编号"
            ></el-input>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->

    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          label="序号"
          width="80"
          fixed
          align="center"
          type="index"
        ></el-table-column>
        <el-table-column
          v-for="(item, index) in localShowTableCols"
          :key="`${index}-${item.name}`"
          :show-overflow-tooltip="true"
          min-width="130"
          align="center"
          :fixed="item.fixable"
          :prop="item.name"
          :label="item.title"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="item.name === 'proveFile'"
              @click="handleShowProveFileDetail(scope.row)"
            >
              {{ scope.row[item.name] }}
            </el-button>
            <el-button
              type="text"
              v-else-if="item.name === 'inWarehouseNum'"
              @click="goToInflowBatch(scope.row)"
            >
              {{ scope.row[item.name] }}
            </el-button>
            <span v-else>
              {{ scope.row[item.name] }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="operationSuper.详情"
          align="center"
          fixed="right"
          label="操作"
          width="170"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleGotoBatchQrcodeTrace(scope.row)"
              >赋码详情</el-button
            >
          </template>
        </el-table-column>
        <div slot="empty" class="figure-data">
          <div class="nodate">
            <img src="../../assets/images/pg-nodata.png" alt="" />
          </div>
        </div>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 表格列设置 -->
    <e6-column-set
      @setColumnSubmit="handleSetColumnSubmit"
      @setColumnCancel="handleSetColumnCancel"
      :columSetVisible.sync="columSetVisible"
      :hideTableCols.sync="copyHideTableCols"
      :showTableCols.sync="copyShowTableCols"
    ></e6-column-set>
    <!-- 表格列设置 end -->
    <el-dialog
      title="检疫合格证详情"
      :visible.sync="proveFileDetailVisible"
      width="670px"
      custom-class="provefile-detail-dialog"
    >
      <el-table :data="proveFileDetailList" height="100%">
        <el-table-column
          label="序号"
          width="80"
          align="center"
          type="index"
        ></el-table-column>
        <el-table-column
          label="检疫合格证名称"
          align="center"
          prop="productFileTypeName"
        ></el-table-column>
        <el-table-column
          label="检疫合格证编号"
          align="center"
          prop="productFileCode"
        ></el-table-column>
        <el-table-column
          label="检疫合格证图片"
          align="center"
          prop="productFileUrl"
        >
          <template slot-scope="scope">
            <e6-image
              style="width: 50px; height: 33px; margin: 0 auto;"
              :src="scope.row.productFileUrl"
              :preview-src-list="[scope.row.productFileUrl]"
            ></e6-image>
          </template>
        </el-table-column>
        <div slot="empty" class="figure-data">
          <div class="nodate">
            <img src="../../assets/images/pg-nodata.png" alt="" />
          </div>
        </div>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  FetchGetTableColumnSettings,
  FetchSaveUserTableColumnSettings
} from "_private/api/public.js";
import { mapGetters, mapActions } from "vuex";
import resizeListener from "_private/mixins/resizeListener";
import { mergeFormExtend } from "_private/utils/merge";
import operationManage from "_private/mixins/operationManage";

import { shortcuts } from "@/utils/dateUtil.js";
import {
  fetchFindFlowOutByPage,
  fetchCorpListByType,
  fetchFlowOutExport,
  fetchOutFlowSummary
} from "@/api/goodsTrace/inflowAndOutflowBatch.js";
import { cloneDeep } from "lodash";
import moment from "moment";
import { exportXlsx } from "@/utils/exportXlsx";

import E6Image from "_private/components/wooden/E6Image/index";

export default {
  mixins: [resizeListener, operationManage],
  components: {
    E6Image
  },
  data() {
    return {
      total: 0, // 总条数
      curPage: 1, // 当前页码
      pageSize: 20, // 每页条目数
      isSearch: false, // 是否展示搜索栏
      datePickerOptions: {
        shortcuts: shortcuts({ d: [0, -1, -2, -7, -30] }, true, 2)
      }, // 时间快捷选择
      parkServiceCorpList: [], // 园区服务企业列表
      parkServiceCorpLoading: false, // 园区服务企业 loading
      foodBusinessCorpList: [], // 食品经营企业列表
      foodBusinessCorpLoading: false, // 食品经营企业 loading
      formExtend: {
        forms: {
          timeRange: [
            moment()
              .startOf("day")
              .format("YYYY-MM-DD HH:mm:ss"),
            moment()
              .endOf("day")
              .format("YYYY-MM-DD HH:mm:ss")
          ], // 时间
          outStorageCode: "", // 出库编号
          storageCompanyId: "", // 园区服务企业id
          foodCompanyId: "", // 食品经营企业id
          goodsName: "", // 商品名称/编号
          startTime: "",
          endTime: "",
          outWarehouseId: []
        },
        extends: []
      },
      tableData: [], // 表格数据
      columSetVisible: false, // 表格列设置
      showTableCols: [],
      hideTableCols: [],
      copyShowTableCols: [],
      copyHideTableCols: [],
      localShowTableCols: [],
      multipleSelection: [],
      loading: false, // 表格 loading
      proveFileDetailVisible: false, // 展示检疫合格证信息
      proveFileDetailList: [], // 要展示的检疫合格证的详细信息
      // 批次概要信息
      batchAbstract: {
        serviceCorp: 0, // 园区服务企业数量
        foodBusinessCorp: 0, // 食品经营企业数量
        goodsType: 0 // 商品类型数
      }
    };
  },
  watch: {
    "formExtend.forms.timeRange": {
      immediate: true,
      handler(val) {
        this.formExtend.forms.startTime = val[0];
        this.formExtend.forms.endTime = val[1];
      }
    }
  },
  computed: {
    ...mapGetters(["moduleId", "searchFormIsOpen", "userId"]),
    columnStr() {
      let columnStr = this.copyShowTableCols.map(item => {
        return item.name;
      });
      return columnStr.length < 1 ? "" : columnStr.join(",");
    }
  },
  created() {
    // 如果当前页面是从批次赋码追溯跳转过来的
    if (this.$route.query.tagTime) {
      let { warehouseCode, tagTime } = this.$route.query;
      let startTime = moment(tagTime)
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      let endTime = moment(tagTime)
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      this.formExtend.forms.timeRange = [startTime, endTime];
      this.formExtend.forms.startTime = startTime;
      this.formExtend.forms.endTime = endTime;
      this.formExtend.forms.outStorageCode = warehouseCode;
    }
    // 如果是从批次流通页面跳转过来
    if (this.$route.query.outWarehouseId) {
      let { outWarehouseId, time } = this.$route.query;
      let outWarehouseIdArr = JSON.parse(outWarehouseId);
      console.log(outWarehouseIdArr);
      let startTime = time;
      let endTime = moment()
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      this.formExtend.forms.timeRange = [startTime, endTime];
      this.formExtend.forms.startTime = startTime;
      this.formExtend.forms.endTime = endTime;
      this.formExtend.forms.outWarehouseId = outWarehouseIdArr;
    }
    this.initSearchSelect();
    this.FetchFindByPage(this.mergeObj());
    this.FetchGetTableColumnSettings({
      moduleId: this.moduleId,
      userId: this.userId
    });
    this.setSearchFormIsOpenAct();
  },

  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    // 初始化下拉菜单
    async initSearchSelect() {
      try {
        this.parkServiceCorpLoading = true;
        this.foodBusinessCorpLoading = true;

        let promiseList = [fetchCorpListByType(2), fetchCorpListByType(1)];

        let [parkServiceRes, foodBusinessRes] = await Promise.all(promiseList);

        if (parkServiceRes.code === 1 && Array.isArray(parkServiceRes.result)) {
          this.parkServiceCorpList = cloneDeep(parkServiceRes.result);
        }
        if (
          foodBusinessRes.code === 1 &&
          Array.isArray(foodBusinessRes.result)
        ) {
          this.foodBusinessCorpList = cloneDeep(foodBusinessRes.result);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.parkServiceCorpLoading = false;
        this.foodBusinessCorpLoading = false;
      }
    },

    // 导出数据
    async exportData() {
      try {
        let res = await fetchFlowOutExport(this.mergeObj());
        let time = moment().format("YYYYMMDDHHmmss");
        exportXlsx(res, `流出批次信息${time}.xlsx`);
      } catch (error) {
        console.log(error);
      }
    },

    // 获取表格数据
    async FetchFindByPage(data) {
      try {
        this.loading = true;
        let promiseList = [
          fetchFindFlowOutByPage(data),
          fetchOutFlowSummary(data)
        ];
        let [pageRes, summaryRes] = await Promise.all(promiseList);
        if (
          pageRes.result &&
          pageRes.result.data &&
          Array.isArray(pageRes.result.data)
        ) {
          this.tableData = pageRes.result.data;
          this.total = pageRes.result.totalRecords;
        }
        if (summaryRes.code === 1 && summaryRes.result) {
          this.batchAbstract.serviceCorp = summaryRes.result.storageCompanyNum;
          this.batchAbstract.foodBusinessCorp =
            summaryRes.result.foodCompanyNum;
          this.batchAbstract.goodsType = summaryRes.result.goodsCategoryNum;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    // 获取表格列列表
    FetchGetTableColumnSettings(data) {
      FetchGetTableColumnSettings(data)
        .then(response => {
          let data = response;
          let showTableCols = [];
          let hideTableCols = [];
          if (data && data.result && Array.isArray(data.result)) {
            data.result.forEach(item => {
              if (item.name === "warehouseCode") {
                item.fixable = "left";
              }
              if (item.show) {
                showTableCols.push(item);
              } else {
                hideTableCols.push(item);
              }
            });
          }
          this.showTableCols = showTableCols;
          this.hideTableCols = hideTableCols;
          this.copyShowTableCols = showTableCols;
          this.copyHideTableCols = hideTableCols;
          this.localShowTableCols = showTableCols;
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 修改表格列列表
    FetchSaveUserTableColumnSettings(data) {
      FetchSaveUserTableColumnSettings(data)
        .then(response => {
          let type = response.code === 1 ? "success" : "error";
          let message = response.message;
          this.$message({
            showClose: true,
            message: message,
            type: type,
            duration: 2000,
            onClose: () => {
              if (type === "success") {
                this.FetchGetTableColumnSettings({
                  moduleId: this.moduleId,
                  userId: this.userId
                });
              }
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        pageParamVO: {
          curPage: this.curPage,
          pageSize: this.pageSize
        }
      });
    },
    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },
    // 查询数据
    handlesSubmitForm() {
      this.curPage = 1;
      this.FetchFindByPage(this.mergeObj());
    },
    // 选择表格列
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 跳转流入批次
    goToInflowBatch(row) {
      this.$router.push({
        path: "/goodsTraceInflowBatch",
        query: {
          inWarehouseDetail: row.inWarehouseDetail.join(",")
        }
      });
    },
    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.FetchFindByPage(this.mergeObj());
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.pageSize = e;
      this.FetchFindByPage(this.mergeObj());
    },
    // 取消表格列设置
    handleSetColumnCancel() {
      this.copyShowTableCols = this.showTableCols;
      this.copyHideTableCols = this.hideTableCols;
    },
    // 确认表格列设置
    handleSetColumnSubmit() {
      this.FetchSaveUserTableColumnSettings({
        moduleId: this.moduleId,
        userId: this.userId,
        columnStr: this.columnStr
      });
    },
    //重置
    handleResetForm() {
      this.formExtend.forms.timeRange = [
        moment()
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss"),
        moment()
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss")
      ]; // 时间
      this.formExtend.forms.outStorageCode = ""; // 出库编号
      this.formExtend.forms.storageCompanyId = ""; // 园区服务企业id
      this.formExtend.forms.foodCompanyId = ""; // 食品经营企业id
      this.formExtend.forms.goodsName = ""; // 商品名称/编号
      this.formExtend.forms.outWarehouseId = [];
    },
    // 导出
    handleExportClick() {
      this.exportData();
    },
    // 跳转到批次赋码追溯
    handleGotoBatchQrcodeTrace(row) {
      this.$router.push({
        path: "/goodsTraceBatchQrcode",
        query: {
          code: row.warehouseCode
        }
      });
    },
    // 展示检疫合格证
    handleShowProveFileDetail(row) {
      this.proveFileDetailList = row.proveFileList;
      this.proveFileDetailVisible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}
.form-section {
  .form-extend {
    .form-item_2 {
      /deep/ .el-form-item__content {
        width: 200px;
        .el-select {
          width: 200px;
        }
      }
    }
  }
}
// 检疫合格证弹出框
/deep/ .provefile-detail-dialog {
  border-radius: 3px;
  .el-dialog__header {
    padding: 15px;
    background-color: #f5f7fa;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    border-bottom: 1px solid #edf0f5;
    .el-dialog__title {
      font-size: 14px;
      line-height: 14px;
      color: #606266;
    }
    .el-dialog__headerbtn {
      top: 13px;
      right: 14px;
    }
  }
  .el-dialog__body {
    padding: 0;
    height: 457px;
    .el-table {
      .el-table__header {
        th {
          background-color: #ffffff;
          border-left: none;
          height: 40px;
          color: #606266;
        }
      }
    }
  }
}
// 信息概要
.batch-abstract {
  .batch-abstract-item {
    margin-left: 20px;
    font-size: 12px;
    color: #909399;
  }
}
/deep/ .el-table__body-wrapper {
  height: calc(100% - 36px) !important;
}
/deep/ .el-table__fixed-body-wrapper {
  height: calc(100% - 36px) !important;
  top: 36px !important;
}
</style>
